<template>
  <div class="item text-white font-extrabold flex flex-col m-3 rounded-lg">
    <h2 class="text-5xl leading-none">{{stat.count}}</h2>
    <h2 class="text-5xl leading-none">{{stat.type}}</h2>
    <p class="text-lg mt-auto">{{stat.description}}</p>
  </div>
</template>

<script>
export default {
  name: "StatItem",
  props: {
    stat: {
      type: Object
    }
  }
};
</script>

<style scoped>
.item {
  background-color:  #FFCE42;
  width: 370px;
  height: 200px;
  padding: 30px;
}
</style>